import React, { useState, useRef, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, addDoc, serverTimestamp, getDocs, query, where, orderBy } from 'firebase/firestore';
import { useParams, useLocation } from 'react-router-dom';
import Header from '../components/HeaderPostLogin';
import Footer from '../components/Footer';
import '../styles/homepage.css';
import { logEvent } from '../utils/analytics/GoogleAnalytics'; // or wherever you define trackEvent
import { trackEvent } from '../utils/analytics/trackEvent.js'; // or wherever you define trackEvent



import AnswerBox from '../components/ai/ahamoment/AnswerBox.jsx';
import TipBox from '../components/ai/ahamoment/TipBox';
import ActionsBox from '../components/ai/ahamoment/ActionsBox';
import SuggestedTopicsBox from '../components/ai/ahamoment/SuggestedTopicsBox';
import { parseAIAIResponse } from '../utils/parseAIAIResponse';






import LoginOverlay from '../components/LoginOverlay';


import AhaLoadingOverlay from '../components/AhaLoadingOverlay';
import AnimatedCoin from '../components/AnimatedCoin';





const FinTorroAhaMomentChatSessionPage = () => {


const [showAuthModal, setShowAuthModal] = useState(false);

const [currentUser, setCurrentUser] = useState(null);




  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const [messageCount, setMessageCount] = useState(1);
  const [showUpgradeBanner, setShowUpgradeBanner] = useState(false);
  const [suggestedTopics, setSuggestedTopics] = useState([]);
  const [collapsedIndex, setCollapsedIndex] = useState(null);
  const [scrollButtonVisible, setScrollButtonVisible] = useState(false);


  const [initialLoading, setInitialLoading] = useState(true);


  const [tokenBalance, setTokenBalance] = useState(100); // default for guests

  const MAX_MESSAGES = 4;
  //const remainingMessages = MAX_MESSAGES - messageCount;
  const remainingMessages = Math.max(MAX_MESSAGES - messageCount, 0);





  const topicPool = [
    'Learn price action',
    'Master candlestick patterns',
    'Understand market trends',
    'Read trading volume',
    'Explore technical analysis',
    'Use moving averages',
    'Set stop loss',
    'Learn risk management',
    'Trade support resistance',
    'Follow trading signals',
    'Understand order types',
    'Time market entries',
    'Analyze market news',
    'Know trader psychology',
    'Practice with papertrades',
    'Study forex pairs',
    'Track interest rates',
    'Explore crypto trends',
    'Learn index funds',
    'Diversify your portfolio',
    'Understand inflation impact',
    'Use RSI indicator',
    'Apply MACD strategy',
    'Identify chart patterns',
    'Recognize bull markets',
    'React to earnings',
    'Know financial statements',
    'Watch economic events',
    'Avoid FOMO trades',
    'Test trading plan',
    'Compare broker fees',
    'Know asset classes',
    'Define trading goals',
    'Review past trades',
    'Use trading journal',
    'Explore ETF basics',
    'Buy low sell',
    'Watch market open',
    'Learn option basics',
    'Explore day trading',
    'Understand long-term',
    'Watch interest yields',
    'Learn about leverage',
    'Understand drawdowns',
    'Practice consistency daily',
    'Understand tax rules',
    'Stay calm trading',
    'Use price alerts',
    'Focus on discipline',
    'Trust trading strategy'
  ];
  
  const getRandomSuggestions = (pool, count = 2) => {
    const shuffled = [...pool].sort(() => 0.5 - Math.random());
    return shuffled.slice(0, count);
  };
  
  const defaultSuggestions = getRandomSuggestions(topicPool);
  

  const chatEndRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const auth = getAuth();
  const db = getFirestore();
  const { chatsessionid } = useParams();
  const location = useLocation();


  const [chatSessionId, setChatSessionId] = useState('');

// useEffect(() => {
//   let storedSessionId = sessionStorage.getItem('fintorro_aha_chatsessionid');
//   if (!storedSessionId) {
//     storedSessionId = crypto.randomUUID();
//     sessionStorage.setItem('fintorro_aha_chatsessionid', storedSessionId);
//   }
//   setChatSessionId(storedSessionId);
// }, []);

useEffect(() => {
  const sessionFromURL = chatsessionid;
  if (sessionFromURL) {
    sessionStorage.setItem('fintorro_aha_chatsessionid', sessionFromURL); // overwrite local
    setChatSessionId(sessionFromURL);
  } else {
    let storedSessionId = sessionStorage.getItem('fintorro_aha_chatsessionid');
    if (!storedSessionId) {
      storedSessionId = crypto.randomUUID();
      sessionStorage.setItem('fintorro_aha_chatsessionid', storedSessionId);
    }
    setChatSessionId(storedSessionId);
  }
}, [chatsessionid]);






useEffect(() => {
  const unsubscribe = auth.onAuthStateChanged(user => {
    setCurrentUser(user);
  });
  return () => unsubscribe();
}, []);

useEffect(() => {
  if (tokenBalance < 3 && !currentUser) {
    trackEvent('aha_out_of_tokens', {
      user_id: 'anonymous',
      chatsessionid: chatSessionId,
      messageid: messageCount + 1, // ✅ Use calculated value
      timestamp: Date.now(),
    });

    setShowAuthModal(true);
  }
}, [tokenBalance, currentUser, chatSessionId, messageCount]);









  const initialQuestion = location.state?.question || 'Why does price reverse after breakout?';

  const [showSidebarMobile, setShowSidebarMobile] = useState(false); // Add this near top

  // const extractSuggestions = (text) => {
  //   const matches = text.match(/\*\*Next Suggestion\*\*:.*?\"(.*?)\"/gs);
  //   if (!matches) return [];
  //   return matches.map(m => m.split('"')[1]);
  // };

  const extractSuggestions = (text) => {
    const lines = text.split('\n');
    const suggestions = [];
  
    lines.forEach(line => {
      const trimmed = line.trim();
  
      // ⛔ Skip Action lines
      if (/^-?\s*Action\s+\d+/i.test(trimmed)) return;
  
      // ✅ Match quoted suggestions
      const match = trimmed.match(/"([^"]+)"/);
      if (match) {
        suggestions.push(match[1]);
      } 
      // ✅ Or match bullet-style suggestions
      else if (trimmed.startsWith('- ') || trimmed.startsWith('•')) {
        const cleaned = trimmed.replace(/^[-•]\s*/, '').trim();
        if (!/^Action\s+\d+/i.test(cleaned)) {
          suggestions.push(cleaned);
        }
      }
    });
  
    return suggestions;
  };
  
  

  const storeLocalSession = (entry) => {
    const existing = JSON.parse(sessionStorage.getItem('fintorro_aha_session') || '[]');
    sessionStorage.setItem('fintorro_aha_session', JSON.stringify([...existing, entry]));
  };

  const fetchSessionFromLocal = () => {
    const all = JSON.parse(sessionStorage.getItem('fintorro_aha_session') || '[]');
    const match = all.filter(item => item.chatsessionid === chatSessionId);
    if (match.length > 0) {
      const restored = match.map((item, idx) => [
        { sender: 'user', text: item.usermessage, timestamp: new Date().toISOString() },
        { sender: 'ai', text: item.airesponse, timestamp: new Date().toISOString() }
      ]).flat();
      // setMessages(restored);
      // setMessageCount(match.length);

      const userMessageCount = restored.filter(m => m.sender === 'user').length;
setMessageCount(userMessageCount);
    }
  };

  const handleScroll = () => {
    const node = scrollContainerRef.current;
    if (node) {
      const { scrollTop, scrollHeight, clientHeight } = node;
      setScrollButtonVisible(scrollHeight - scrollTop > clientHeight + 150);
    }
  };

  useEffect(() => {
    const fetchInitialAIResponse = async () => {
      if (!chatSessionId) return; // ✅ Guard: don't run unless ready
  
      try {
        const user = auth.currentUser;
        const userId = currentUser?.uid || null;
  
        const dbQuery = await getDocs(
          query(
            collection(db, 'user_learn_aha_moment_ai_interactions'),
            where('chatsessionid', '==', chatSessionId),
            orderBy('messageid')
          )
        );
  
        if (!dbQuery.empty) {
          const restoredMessages = [];
          let lastMessageCount = 0;
          let suggestions = [];
  
          dbQuery.forEach(doc => {
            const data = doc.data();
            restoredMessages.push({ sender: 'user', text: data.usermessage, timestamp: new Date().toISOString() });
            restoredMessages.push({ sender: 'ai', text: data.airesponse, timestamp: new Date().toISOString() });
  
            if (data.topicsuggested && Array.isArray(data.topicsuggested) && data.topicsuggested.length > 0) {
              suggestions = [...data.topicsuggested];
            }
  
            if (data.messageid > lastMessageCount) {
              lastMessageCount = data.messageid;
            }
          });

          
  
          setMessages(restoredMessages);
          setMessageCount(1); // Only 1 user message initially


          trackEvent('aha_session_loaded', {
            user_id: userId || 'anonymous',
            chatsessionid: chatSessionId,
            message_count: newMessages.length,
            
            timestamp: Date.now(),
          });
          

          setSuggestedTopics(suggestions.length > 0 ? suggestions : defaultSuggestions);
          setMessageCount(lastMessageCount);
          setInitialLoading(false);
          return;
        }
  
        // Fallback: No DB results
        const response = await fetch('https://mcp-server-fintorro.onrender.com/ahaMomentAiChat', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'x-aimodel': 'openai' },
          body: JSON.stringify({
            userid: userId || 'anonymous',
            chatsessionid: chatSessionId,
            usermessage: initialQuestion,
            messageCount: 0
          })
        });
  
        const data = await response.json();
        const aiResponse = data.airesponse || '⚠️ Sorry, no response generated. Try again.';
        const extracted = extractSuggestions(aiResponse);
  
        const newMessages = [
          { sender: 'user', text: initialQuestion, timestamp: new Date().toISOString() },
          { sender: 'ai', text: aiResponse, timestamp: new Date().toISOString() },
        ];


  
        setMessages(newMessages);

        trackEvent('aha_initial_question_sent', {
          user_id: userId || 'anonymous',
          chatsessionid: chatSessionId,
          messageid: 1,
          
          message_length: initialQuestion.length,
          timestamp: Date.now(),
        });
        


        setSuggestedTopics(extracted.length > 0 ? extracted : defaultSuggestions);
        setInitialLoading(false);
  
        if (!user) {
          storeLocalSession({
            userid: 'anonymous',
            chatsessionid: chatSessionId,
            usermessage: initialQuestion,
            airesponse: aiResponse,
            timestamp: new Date().toISOString()
          });
        }
      } catch (err) {
        console.error('❌ Initial AI fetch failed', err);
        setInitialLoading(false);
      }
    };
  
    fetchInitialAIResponse();
  }, [chatSessionId]);
  





  useEffect(() => {
    const container = scrollContainerRef.current;
    container?.addEventListener('scroll', handleScroll);
    return () => container?.removeEventListener('scroll', handleScroll);
  }, []);

  // const handleSend = async () => {
    
  //   if (loading) return; // 🛑 Prevent multiple submissions
  //   if (!input.trim()) return;
  //   const userMessage = input.trim();
    

  //   trackEvent('aha_ask_ai_button_clicked', {
  //     screen: 'FinTorroAhaMomentChatSessionPage',
  //     user_id: userId || 'anonymous',
  //     chatsessionid: chatSessionId,
      
  //     message_length: userMessage.length,
  //     messageid: newMessageId,
  //     timestamp: Date.now(),
  //   });


  const handleSend = async () => {
    if (loading) return;
    if (!input.trim()) return;
  
    const userMessage = input.trim();
   //const userId = auth.currentUser?.uid || null;
   const userId = currentUser?.uid || null;

   setMessageCount(prev => prev + 1);

   const newMessageId = messageCount + 1;
  
    trackEvent('aha_ask_ai_button_clicked', {
      screen: 'FinTorroAhaMomentChatSessionPage',
      user_id: userId || 'anonymous',
      chatsessionid: chatSessionId,
      message_length: userMessage.length,
      messageid: newMessageId,
      timestamp: Date.now(),
    });





    

   

    // if (!userId && newMessageId === 15) {
    //   setShowAuthModal(true);
    // }

    // if (!auth.currentUser && tokenBalance < 30) {
    //   if (!currentUser && tokenBalance < 30) {

    //   setShowAuthModal(true);
    //   return;
    // }

    if (!currentUser && messageCount + 1 > MAX_MESSAGES) {
      setShowAuthModal(true);
      trackEvent('aha_out_of_tokens_modal_shown', {
        user_id: 'anonymous',
        chatsessionid: chatSessionId,
        messageid: messageCount + 1,
        timestamp: Date.now(),
      });
      return;
    }
    
    
    
    setMessages(prev => [...prev, { sender: 'user', text: userMessage, timestamp: new Date().toISOString() }]);
    trackEvent('aha_followup_ai_question_sent', {
      screen: 'FinTorroAhaMomentChatSessionPage',
      user_id: userId || 'anonymous',
      chatsessionid,
      message_length: userMessage.length,
      
      messageid: newMessageId,
      timestamp: Date.now()
    });
    
    setInput('');
    setLoading(true);
    setMessageCount(newMessageId);

    try {
      const response = await fetch('https://mcp-server-fintorro.onrender.com/ahaMomentAiChat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'x-aimodel': 'openai' },
        body: JSON.stringify({ userid: userId || 'anonymous', chatsessionid: chatSessionId, usermessage: userMessage, messageCount: newMessageId - 1 })
      });

      const data = await response.json();
      const aiResponse = data.airesponse || '⚠️ Sorry, no response generated. Try again.';
      const extracted = extractSuggestions(aiResponse);

      const aiMsg = { sender: 'ai', text: aiResponse, timestamp: new Date().toISOString() };
      setMessages(prev => [...prev, aiMsg]);
      trackEvent('aha_ai_response_received', {
        user_id: userId || 'anonymous',
        chatsessionid: chatSessionId,
        messageid: newMessageId,
        
        response_length: aiResponse.length,
        modelused: 'openai', // or 'gemini-flash' depending on what you use
        timestamp: Date.now(),
      });
      
      setSuggestedTopics(extracted.length > 0 ? extracted : defaultSuggestions);

      // 🎯 Deduct 30 tokens for anonymous users
// if (!auth.currentUser) {
//   setTokenBalance(prev => Math.max(prev - 30, 0)); // never go negative
// }

// if (!currentUser) {
//   setTokenBalance(prev => Math.max(prev - 30, 0));
// }

if (!currentUser && newMessageId <= MAX_MESSAGES) {
  setTokenBalance(prev => Math.max(prev - 30, 0));
}


      const doc = {
        userid: userId,
        chatsessionid,
        usermessage: userMessage,
        airesponse: aiResponse,
        modelused: 'gemini-flash', //need to change it based on the model used
        messageid: newMessageId,
        messageCount: newMessageId - 1,
        timestamp: serverTimestamp(),
      };

      //commented this as this is already handled in server.py

     // await addDoc(collection(db, 'user_learn_aha_moment_ai_interactions'), doc);
      //if (!userId) storeLocalSession(doc);

      
// REPLACE WITH THIS
if (!userId) {
  storeLocalSession({
    userid: 'anonymous',
    chatsessionid: chatSessionId,
    usermessage: userMessage,
    
    airesponse: aiResponse,
    timestamp: new Date().toISOString()
  });
}





      if (newMessageId >= MAX_MESSAGES) setShowUpgradeBanner(true);
      trackEvent('aha_upgrade_prompt_shown', {
        user_id: userId || 'anonymous',
        chatsessionid: chatSessionId,
        
        total_messages: newMessageId,
        timestamp: Date.now(),
      });
      

    } catch (err) {
      console.error('❌ Send error', err);
      setMessages(prev => [...prev, { sender: 'ai', text: '⚠️ Something went wrong. Try again later.', timestamp: new Date().toISOString() }]);
    } finally {
      setLoading(false);
      chatEndRef.current?.scrollIntoView({ behavior: 'smooth' });
    }
  };

// 👇 This is where you insert the scroll-locking logic
useEffect(() => {
  if (initialLoading) {
    document.body.style.overflow = 'hidden';
  } else {
    document.body.style.overflow = 'auto';
  }

  return () => {
    document.body.style.overflow = 'auto'; // cleanup when unmounts
  };
}, [initialLoading]);

// Example: dismiss loading overlay after data fetch
useEffect(() => {
  // Simulate API delay
  const timer = setTimeout(() => {
    setInitialLoading(false);
  }, 10000);

  return () => clearTimeout(timer);
}, []);

  




  const formatMessage = (text) => text.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>').replace(/\n/g, '<br />');

  return (
    <>
      <Header />

      {/* Code for the initial animation loading */}

      {initialLoading && <AhaLoadingOverlay />}

      

<main
  style={{
    backgroundColor: '#232830',
    color: '#fff',
    minHeight: '100vh',
    paddingTop: '80px',
    fontFamily: 'Nunito Sans, sans-serif',
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  }}
>
  {/* 📱 Mobile Sidebar Toggle Button */}
  <button
    onClick={() => setShowSidebarMobile(!showSidebarMobile)}
    style={{
      display: 'none',
      position: 'fixed',
      top: '90px',
      left: '20px',
      zIndex: 1000,
      backgroundColor: '#FF7C24',
      color: '#fff',
      border: 'none',
      padding: '0.5rem 1rem',
      borderRadius: '8px',
      fontWeight: '700',
    }}
    className="toggle-sidebar"
  >
    📘 History
  </button>

  {/* 📘 Sidebar */}
  <aside
    className={`learning-sidebar ${showSidebarMobile ? 'sidebar-visible' : ''}`}
    style={{
      width: '260px',
      background: '#181B1F',
      padding: '1rem',
      overflowY: 'auto',
    }}
  >
    <h3 style={{ color: '#FF7C24', fontSize: '18px' }}>📘 Learning History</h3>
    {messages
      .filter((m) => m.sender === 'user')
      .map((m, i) => (
        <div key={i} style={{ color: '#fff', fontSize: '14px', marginTop: '1rem' }}>
          {m.text}
        </div>
      ))}
  </aside>

    {/* Main Chat Section */}
    <section
      ref={scrollContainerRef}
      style={{
        flex: 1,
        padding: '1rem',
        overflowY: 'auto',
        backgroundColor: '#232830',
        width: '100%',
      }}
    >

{initialLoading && (
  <div style={{
    textAlign: 'center',
    marginTop: '2rem',
    color: '#FF7C24',
    fontWeight: 'bold',
    fontSize: '18px',
    animation: 'fadein 1.5s ease-in-out infinite',
  }}>
    🧠 Loading your Aha Moment...
  </div>
)}


{/* 
      {!initialLoading && messages.map((msg, i) => {
        const isAI = msg.sender === 'ai';
        const isCollapsed = collapsedIndex === i;
        const formatted = formatMessage(msg.text);
        const preview = formatted.split(/<br\s*\/?>/).slice(0, 12).join('<br />');

        return (
          <div key={i} style={{ marginBottom: '1.5rem' }}>
            <div
              style={{
                backgroundColor: isAI ? '#1C1C1C' : '#007bff',
                color: '#fff',
                padding: '1rem',
                borderRadius: '16px',
                maxWidth: '90%',
                marginLeft: isAI ? '0' : 'auto',
                fontSize: '16px',
                lineHeight: '1.6',
                boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                cursor: isAI ? 'pointer' : 'default',
              }}
              onClick={() => isAI && setCollapsedIndex(isCollapsed ? null : i)}
              dangerouslySetInnerHTML={{
                __html: isAI && isCollapsed ? preview + '<br/><br/>⬇️ Click to expand' : formatted,
              }}
            />
            <div
              style={{
                fontSize: '12px',
                color: '#bbb',
                marginTop: '0.5rem',
                textAlign: isAI ? 'left' : 'right',
                fontStyle: 'italic',
              }}
            >
              {new Date(msg.timestamp).toLocaleTimeString()}
            </div>
          </div>
        );
      })} */}


{!initialLoading && messages.map((msg, i) => {
  const isAI = msg.sender === 'ai';
  const parsed = isAI ? parseAIAIResponse(msg.text) : null;
  const isStructured = parsed && (parsed.answer || parsed.tip || parsed.actions.length > 0 || parsed.topics.length > 0);

  return (
    <div key={i} style={{ marginBottom: '1.5rem' }}>
      {/* 👤 USER MESSAGE */}
      {!isAI && (
        <>
          <div style={{
            backgroundColor: '#007bff',
            color: '#fff',
            padding: '1rem',
            borderRadius: '16px',
            maxWidth: '90%',
            marginLeft: 'auto',
            fontSize: '16px',
            lineHeight: '1.6',
            fontFamily: 'Nunito Sans',
            boxShadow: '0 2px 6px rgba(0,0,0,0.3)'
          }}>
            {msg.text}
          </div>
          <div style={{
            fontSize: '12px',
            color: '#bbb',
            marginTop: '0.5rem',
            textAlign: 'right',
            fontStyle: 'italic',
            fontFamily: 'Nunito Sans',
          }}>
            {new Date(msg.timestamp).toLocaleTimeString()}
          </div>
        </>
      )}

      {/* 🤖 AI STRUCTURED or FALLBACK */}
      {isAI && (
        <>
          {isStructured ? (
            <>
              {parsed.answer && <AnswerBox>{parsed.answer}</AnswerBox>}
              {parsed.tip && <TipBox>{parsed.tip}</TipBox>}
              {parsed.actions.length > 0 && <ActionsBox actions={parsed.actions} />}
              {parsed.topics.length > 0 && <SuggestedTopicsBox topics={parsed.topics} />}
            </>
          ) : (
            <AnswerBox>{msg.text}</AnswerBox>
          )}
          <div style={{
            fontSize: '12px',
            color: '#bbb',
            marginTop: '0.5rem',
            textAlign: 'left',
            fontStyle: 'italic',
            fontFamily: 'Nunito Sans',
          }}>
            {new Date(msg.timestamp).toLocaleTimeString()}
          </div>
        </>
      )}
    </div>
  );
})}



      


      {/* {loading && <div style={{ fontStyle: 'italic', color: '#ccc', marginTop: '1rem' }}>🤖 Thinking...</div>} */}

      {loading && (
  <div
    style={{
      textAlign: 'center',
      color: '#FF7C24',
      fontWeight: 'bold',
      fontSize: '18px',
      marginTop: '2rem',
      animation: 'pulse 1.5s infinite',
    }}
  >
    🧠 Hang tight, your insight is being crafted...
  </div>
)}




      <div ref={chatEndRef}></div>

      {suggestedTopics.length > 0 && (
        <div
          style={{
            marginTop: '1rem',
            backgroundColor: '#2D2D2D',
            padding: '1rem',
            borderRadius: '12px',
          }}
        >
          <p style={{ fontWeight: '600', textAlign: 'center', color: '#fff' }}>📌 Suggested Next Topics to Learn  </p>
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '0.5rem',
              justifyContent: 'center',
            }}
          >
           {suggestedTopics
  .filter(topic => !/^Action\s+\d+/i.test(topic))
  .map((topic, idx) => (
    <button
    key={idx}
    onClick={() => {
      trackEvent('aha_suggestion_click', {
        screen: 'FinTorroAhaMomentChatSessionPage',
        topic: topic,
        user_id: auth.currentUser?.uid || 'anonymous',
        
        chatsessionid,
        timestamp: Date.now()
      });
      setInput(topic);
      handleSend();
    }}
  
      style={{
        padding: '0.6rem 1rem',
        borderRadius: '10px',
        backgroundColor: '#fff',
        color: '#232830',
        fontWeight: '600',
        border: 'none',
        cursor: 'pointer',
      }}
    >
      {topic}
    </button>
))}

          </div>
        </div>
      )}

      {/* <div
        style={{
          marginTop: '1rem',
          marginBottom: '0.75rem',
          backgroundColor: '#fff',
          color: '#FF7C24',
          padding: '8px 14px',
          borderRadius: '12px',
          fontWeight: '700',
          fontSize: '15px',
        }}
      >
        🧠 You have {remainingMessages} free messages left
      </div> */}

{!auth.currentUser && (
  <div
    style={{
      marginTop: '1rem',
      marginBottom: '0.75rem',
      backgroundColor: '#fff',
      color: '#FF7C24',
      padding: '8px 14px',
      borderRadius: '12px',
      fontWeight: '700',
      fontSize: '15px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '0.5rem',
    }}
  >
    💰 <span style={{ fontWeight: '800' }}>{tokenBalance}</span> Tokens left
  </div>
)}


      {/* <AnimatedCoin /> */}

      {/* Input Section */}
      {/* <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
        }}
      >
        <textarea
          rows={3}
          value={input}
          onChange={(e) => setInput(e.target.value)}
          placeholder="Type your next question..."
          style={{
            borderRadius: '12px',
            border: '1px solid #ccc',
            padding: '1rem',
            fontSize: '1rem',
            backgroundColor: '#fff',
            color: '#232830',
            width: '100%',
          }}
        />
        <button
          onClick={handleSend}
          disabled={loading || !input.trim()}
          style={{
            backgroundColor: '#FF7C24',
            color: '#fff',
            fontWeight: '700',
            padding: '0.75rem 1.5rem',
            borderRadius: '12px',
            fontSize: '1rem',
            border: 'none',
            cursor: 'pointer',
            alignSelf: 'flex-end',
          }}
        >
        {loading ? "Thinking..." : "Ask AI"}
  </button>
      </div> */}
 
 {/* {tokenBalance < 30 && !auth.currentUser ? ( */}

 {tokenBalance < 30 && !currentUser ? (
  <>
    <div style={{ color: '#fff', fontWeight: '600', padding: '1rem', textAlign: 'center' }}>
      🛑 You're out of tokens! <br />
      <button
        style={{
          marginTop: '1rem',
          backgroundColor: '#FF7C24',
          color: '#fff',
          padding: '0.6rem 1.2rem',
          borderRadius: '10px',
          border: 'none',
          fontWeight: '700',
          cursor: 'pointer'
        }}
        onClick={() => {
          trackEvent('aha_upgrade_button_click', {
            user_id: 'anonymous',
            
            chatsessionid: chatSessionId,
            timestamp: Date.now(),
          });
          setShowAuthModal(true);
        }}
        
      >
        🔓 Unlock More with Free Signup
      </button>
    </div>

    {/* Optional animation or lock UI */}
  </>
) : (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
    }}
  >
    <textarea
      rows={3}
      value={input}
      onChange={(e) => setInput(e.target.value)}
      placeholder="Type your next question..."
      style={{
        borderRadius: '12px',
        border: '1px solid #ccc',
        padding: '1rem',
        fontSize: '1rem',
        backgroundColor: '#fff',
        color: '#232830',
        width: '100%',
      }}
    />
    <button
      onClick={handleSend}
      disabled={loading || !input.trim()}
      style={{
        backgroundColor: '#FF7C24',
        color: '#fff',
        fontWeight: '700',
        padding: '0.75rem 1.5rem',
        borderRadius: '12px',
        fontSize: '1rem',
        border: 'none',
        cursor: 'pointer',
        alignSelf: 'flex-end',
      }}
    >
      {loading ? "Thinking..." : "Ask AI"}
    </button>
  </div>
)}

      <p
        style={{
          fontSize: '13px',
          textAlign: 'center',
          color: '#fff',
          backgroundColor: '#2D2D2D',
          borderRadius: '8px',
          padding: '0.75rem',
          marginTop: '1.5rem',
        }}
      >
        🤖 AI can make mistakes. Please use with discretion.
      </p>
    </section>

</main>

      {showAuthModal && (
  <LoginOverlay
    heading="🚀 Join FinTorro"
    description="Log in or create a free account to continue your Aha Moment journey."
    redirectUrl="/agent-access"
    onClose={() => setShowAuthModal(false)}
  />
)}



      {/* <Footer /> */}
    </>
  );
};

export default FinTorroAhaMomentChatSessionPage;
